import React from 'react'
import "./project.css"
import data from '../data/data.json'

const Project = () => {
    const project = data.project;
  return (
   <section className='project section' id='project'>
        <h2 className='section__title'>Project</h2>
        <span className='section__subtitle'>My Project</span>
        <div className="project__container container grid">
            {
                project.map(({title,github,production,description,tec})=>{
                    return(
                        <div className="project__content">
                            <div className='project__icons'>
                                <a href={(production == "") ? "#" : production}><i className='uil uil uil-folder  project__icon '></i></a>
                                <a href={(github == "") ? "#" : github}><i className='uil uil uil-github-alt  project__icon text-right'></i></a>
                                <a href={(production == "") ? "#" : production}><i className='uil uil uil-external-link-alt  project__icon text-right'></i></a>
                            </div>
                            <div className="project__title">
                                <h3>{title}</h3>
                            </div>
                            <div className="project__description">
                                <p>{description}</p>
                            </div>
                            <div className="project__footer">
                                <span className='project__info'>{tec}</span>
                            </div>
                        </div>
                        )
                    })
                } 
        </div>
   </section>
  )
}

export default Project